import { Component, OnInit } from '@angular/core';
import { AppFilter } from '@app/shared/models';
import { ModalSize, SuiModalService } from '@richardlt/ng2-semantic-ui';
import { ConfirmModal } from '@app/shared/modals/confirm-modal/confirm-modal.component';
import { GeofencingMgtService } from '../../services/geofencing-mgt.service';
import { editGeofenceProfileModal } from '../../modals/edit-geofence-modal/edit-geofence-modal.component';
import { PermissionService } from '../../services/permission.service';

interface IHeaders {
  field?: string;
  label?: string;
  type?: string;
  choices?: any[];
  op?: string;
  data?: any;
}

@Component({
  selector: 'app-geofence-user-profile-settings',
  templateUrl: './geofence-user-profile-settings.component.html',
  styleUrls: ['./geofence-user-profile-settings.component.scss'],
})
export class GeofenceUserProfileSettingsComponent implements OnInit {
  filter: AppFilter = new AppFilter();
  pending: boolean;
  rows: number = 2;
  currentPage: number = 1;
  maxSize: number = 7;
  success: any;
  error: any;
  profiles: any = [];
  totalItems: number;

  searchFilter = {
    groupOp: 'OR',
    rules: [
      {
        field: 'profileName',
        op: 'cn',
        data: '',
      },
      {
        field: 'countries',
        op: 'cn',
        data: '',
      },
    ],
  };
  constructor(
    private permissionService: PermissionService,
    private modalService: SuiModalService,
    private geofenceSvc: GeofencingMgtService
  ) {
    this.filter = new AppFilter({
      sidx: 'dateCreated',
      rows: 10,
      sord: 'desc',
    });

    this.getProfiles(1);
    this.totalItems = this.profiles.length;
  }
  headerFilters: any[];
  headers: IHeaders[] = [
    {
      field: 'profileName',
      label: 'Profile Name',
      type: 'text',
      op: 'cn',
      data: '',
    },
    {
      field: 'countries',
      label: 'Countries',
      type: 'text',
      op: 'cn',
      data: '',
    },
  ];

  ngOnInit(): void {}

  getPage(any: number) {}

  editProfile(user) {
    this.modalService
      .open(
        new editGeofenceProfileModal(
          'Edit Geofence Profile',
          {
            isAdd: false,
            profileName: user.profileName,
            countries: user.countries,
            profileId: user.geoFenceProfileId,
          },
          ModalSize.Normal
        )
      )
      .onApprove(() => {
        this.getProfiles(1);
      })
      .onDeny(() => {});
  }

  getProfiles(page) {
    this.filter.page = page;
    this.pending = true;
    this.geofenceSvc.getGeofenceProfiles({ params: this.filter }).subscribe(
      (res: any) => {
        this.pending = false;
        this.profiles = res['rows'];
        this.totalItems = +res['records'];
      },
      (error) => {
        this.pending = false;
        this.error = error.error ? error.error : error;
      }
    );
  }

  addProfile() {
    this.modalService
      .open(
        new editGeofenceProfileModal(
          'Add Geofence Profile',
          {
            isAdd: true,
          },
          ModalSize.Normal
        )
      )
      .onApprove(() => {
        this.getProfiles(1);
      })
      .onDeny(() => {});
  }
  deleteProfile(user) {
    this.pending = true;
    this.geofenceSvc
      .deleteGeofenceProfile({
        geofenceProfileId: user.geofenceProfileId,
      })
      .subscribe(
        (res) => {
          this.pending = false;
          this.success = 'Profile Deleted Succesfully';
        },
        (error) => {
          this.pending = false;
          this.error = error.error ? error.error : error;
        }
      );
  }
  delete(user) {
    this.modalService
      .open(
        new ConfirmModal(
          'Delete Geofence Profile',
          'Are you sure you want to delete this Geofence Profile?',
          ModalSize.Normal
        )
      )
      .onApprove(() => {
        this.deleteProfile(user);
      })
      .onDeny(() => {});
  }

  searchRecords(search) {
    let searchFilter = {
      groupOp: 'OR',
      rules: [
        {
          field: 'profileName',
          op: 'cn',
          data: '',
        },
        {
          field: 'countries',
          op: 'cn',
          data: '',
        },
      ],
    };
    searchFilter.rules[0].data = search;
    searchFilter.rules[1].data = search;
    this.filter.filters = JSON.stringify(searchFilter);
    this.getProfiles(11);
  }
  cancelAd() {
    this.filter = new AppFilter({
      page: 1,
      rows: this.rows,
      _search: false,
    });
    this.getProfiles;
  }
  advancedSearch(search) {
    console.log(search, 'search');
    if (search) {
      // this.filter = search;
      this.filter._search = true;
      this.filter.filters = JSON.stringify(search);
    } else {
      this.filter.filters = {};
      this.filter._search = false;
    }
    this.currentPage = 1;
    this.filter.page = this.currentPage;
    this.filter.sidx = 'dateCreated';
    this.getProfiles(1);
    // console.log(this.filter);
  }
  sortRecords(search) {
    this.filter.sord = search;
    this.filter.sidx = 'desc';
    this.getProfiles(1);
  }

  //handles rows display
  displayRecords(row) {
    this.filter['rows'] = row;
    this.getProfiles(1);
  }

  nextPage(page: number) {
    //get and assign current page
    this.currentPage = page;
    this.getProfiles(this.currentPage);
  }

  checkPermission(event: { id: string; action: string }): boolean {
    const { id, action } = event;
    return this.permissionService.checkPermission(id, action);
  }
}
